import { useState } from "react";

import { iniciaisDoNome } from "@/lib/ficha-da-equipe";
import { cn } from "@/lib/utils";

/**
 * TUT-551 — a foto da pessoa da equipe, ou as iniciais quando não há foto (ou
 * quando a imagem falha). Não é o logo do escritório: esse sai só pela
 * `MarcaDoEscritorio` (P53).
 *
 * `FotoOuIniciais` é o miolo, para quem já tem a moldura (o menu da conta, que
 * pinta o círculo pelo `profileMenuClass`). A imagem é decorativa (`alt=""`):
 * o nome está sempre escrito ao lado, ou no nome acessível de quem a contém.
 */
export function FotoOuIniciais({
  fotoUrl,
  iniciais,
  alt = "",
}: {
  fotoUrl: string | null | undefined;
  iniciais: string;
  alt?: string;
}) {
  // A falha vale para a URL que falhou: foto nova é URL nova (`?v=`).
  const [falhou, setFalhou] = useState<string | null>(null);
  if (fotoUrl && falhou !== fotoUrl) {
    return (
      <img
        src={fotoUrl}
        alt={alt}
        className="block size-full rounded-full object-cover"
        onError={() => setFalhou(fotoUrl)}
      />
    );
  }
  return <span aria-hidden={alt ? undefined : true}>{iniciais}</span>;
}

const TAMANHOS = {
  /** Na linha da tabela de Usuários. */
  linha: "size-8 text-legenda",
  /** No alto da ficha. */
  ficha: "size-[4.5rem] text-titulo",
} as const;

export function AvatarDaPessoa({
  nome,
  fotoUrl,
  tamanho = "linha",
  rotulo,
  className,
}: {
  nome: string;
  fotoUrl: string | null | undefined;
  tamanho?: keyof typeof TAMANHOS;
  /** O nome acessível da imagem, quando ela não é só decoração (a foto da ficha). */
  rotulo?: string;
  className?: string;
}) {
  return (
    <span
      data-avatar-da-pessoa=""
      className={cn(
        "inline-grid flex-none place-items-center overflow-hidden rounded-full border border-[var(--border-strong)] bg-[var(--surface-2)] font-semibold text-[var(--text)]",
        TAMANHOS[tamanho],
        className,
      )}
    >
      <FotoOuIniciais fotoUrl={fotoUrl} iniciais={iniciaisDoNome(nome)} alt={rotulo} />
    </span>
  );
}
